module.exports = __webpack_public_path__ + "static/media/Dextone.9127f01d.png";